import dayjs from "dayjs";
import { Activity } from "../../../pages/logbook/pages/main/components/shared/formActivity/create/types";
import { UserFilterResponse } from "../../user/response"
import { Data, DataWithErrors, ResponseDataActivity, ResponseTypeActivity, ResponseUnits, ResponseUserData } from "../response"
import { getErrorCode } from "../../../pages/logbook/pages/main/components/shared/formActivity/create/constants/getErrorcode";
import { ErrorsCode } from "../../../pages/logbook/pages/main/components/shared/formActivity/create/enums/errorsCodes";
import { TFunction } from "react-i18next";
import { ActivityData, ActivityDataWithoutUser, UserData } from "../../../pages/logbook/pages/main/components/shared/formActivity/edit/types";
import { DestinationType } from "../../../pages/logbook/pages/main/components/shared/formActivity/create/enums/destinationType";
import { formatGeneralEvidenceConfig } from "../../../components/uploadEvidence/methods";
import utc from "dayjs/plugin/utc";
import { Constants } from "../../../utils/constants";

dayjs.extend(utc);

const formatUsersDataListResponse = ({ response }: { response: ResponseUserData }) => {

    const row = response?.items.map((item) => {
        return {

            id: item.id,
            firstName: item.firstName,
            lastName: item.lastName,
            username: item.username,
            roleId: item.roleId,
            userTypeId: item.userTypeId,
            gender: item.gender,
            userType: item.userType,
            role: item.role,
            roleName: item.roleName,
            curp: item.curp,
            phone: item.phone,
            email: item.email,
            picture: item.picture,
            divisionId: item.divisionId,
            division: item.division,
            cveDivision: item.cveDivision,
            userTypeDescription: item.userType?.name ?? 'N/A',
            activities: [],
            errors: [],
            area: item?.userDepartments.map((area) => area.name) ?? [],
            department: item?.userDepartments.flatMap((area) =>
                area.departaments.map((dept) => dept.name)
            ) ?? [],
            userDepartments: item.userDepartments ?? [], 

        }
    })
        ?? []

    return {
        row
    }
}


const formatUsersDataUnitsResponse = ({ response }: { response: ResponseUnits }) => {

    const totalPages = !response.errors ? response.totalPages : 1
    const row = !response.errors ?
        response?.items.map((item) => {
            return {
                id: item.id,
                name: item.name,
                keyCode: item.keyCode,
                latitude: item.latitude,
                longitude: item.longitude,
                zoneId: item.zoneId,
                zoneName: item.zoneName,
                divisionId: item.divisionId,
                divisionDescription: item.divisionDescription,
                storeTimeZone: {
                    id: 1,
                    zone: item.timezoneZone,
                    code: item.timezoneCode,
                    value: item.timezoneValue
                }
            }
        })
        : []

    return {
        row,
        totalPages
    }
}

const formatActivityDataResponse = ({ response }: { response: ResponseDataActivity }) => {

    const status = response.status.id
    const isFree = !response.dateEnd && !response.dateStart
    const generalConfig = formatGeneralEvidenceConfig({ config: response.currentTypeActivity?.configEvidences })
    const evidences = response.evidences
    const geofence = response.geofence
    const user: UserData = {
        id: response.user?.id ?? 0,
        name: `${response.user?.firstName} ${response.user?.lastName}`,
        role: response.user?.role.description ?? 'N/A',
        area: response.user?.userDepartments.map((area) => area.name) ?? [],
        department: response.user?.userDepartments.flatMap((area) =>
            area.departaments.map((dept) => dept.name)
        ) ?? [],
        division: response.user?.division?.description ?? ''
    }

    let activity: ActivityData | undefined;
    let activityWithoutUser: ActivityDataWithoutUser | undefined;

    if (!response.geofence) {

        const [latitude, longitude] = response.storeInit ? [Number(response.storeInit.latitude), Number(response.storeInit.longitude)] : response.locationInitSite ? response.locationInitSite.split(",").map(coord => parseFloat(coord.trim())) : [Number(response.place?.latitude), Number(response.place?.length)];
        const transformDateStart = dayjs.utc(response.dateStart).format(Constants.dayjsFormat3)
        const transformDateEnd = dayjs.utc(response.dateEnd).format(Constants.dayjsFormat3)

        activity= {
            id: String(response.id),
            startDate: response.dateStart ? dayjs(transformDateStart) : null,
            endDate: response.dateEnd ? dayjs(transformDateEnd) : null,
            name: response.title,
            observation: response.description,
            activityTypeText: response.activityTypeText,
            type: response.typeActivity ? {
                label: response.currentTypeActivity?.title,
                value: String(response.currentTypeActivity?.id),
                openField: response.currentTypeActivity?.openField
            } : undefined,
            destination: {
                id: response.storeInit ? response.storeInit.id : null,
                latitude: latitude,
                longitude: longitude,
                name: response.storeInit ? response.storeInit.name : response.locationInitSiteName ? String(response.locationInitSiteName) : String(response.place?.name),
                type: response.storeInit ? DestinationType.UNITY : DestinationType.DESTINATION,
                timeZone: response.storeInit ? response.storeInit.storeTimeZone : undefined,
                companyName: response.company?.name,
                compnayId: response.companyId ?? undefined,
                direction: response.placeAddress ?? undefined,
                idDestnation: response.place?.id ? response.place?.id : response.storeInit?.id ? null : Date.now(),
                toCreate: false,
                toCreateSelected: !!response.place?.id
            }
        }
    }else{
        activityWithoutUser= {
            id: String(response.id),
            name: response.title,
            observation: response.description,
            activityTypeText: response.activityTypeText,
            type: response.typeActivity ? {
                label: response.currentTypeActivity?.title,
                value: String(response.currentTypeActivity?.id),
                openField: response.currentTypeActivity?.openField
            } : undefined,
        }
    }


    return {
        user,
        status,
        activity,
        generalConfig,
        evidences,
        geofence,
        activityWithoutUser,
        isFree
    }
}

const formatTypeActivityResponse = ({ response }: { response: ResponseTypeActivity }) => {


    const items = !response.errors ?
        response?.map((item) => {
            return {
                label: item.title,
                value: item.id,
                openField: item.openField,
                configTypeActivityEvidence: formatGeneralEvidenceConfig({ config: item.configTypeActivityEvidence })
            }
        })
        : []

    return {
        items
    }
}

/* /* const transformDataToActivity = (data: Data): Activity => ({
    id: data.idActivity,
    name: data.title,
    type: {
        value: String(data.typeActivityId),
        label: data.typeActivityLabel
    },
    startDate: dayjs(data.dateStart),
    endDate: dayjs(data.dateEnd),
    destination: {
        name: data.locationName,
        latitude: Number(data.latitude),
        longitude: Number(data.longitude),
        type: data.typeDestination,
        id: data.storeId,
        timeZone: {
            id: 0,
            zone: data.timeZone,
            code: data.timeZone,
            value: 0
        }
    }
}); */

const transformErrorActivity = (data: DataWithErrors | undefined, t: TFunction<'translation', undefined>): string[] => {

    if (!data) {
        return [];
    }

    const userErrors = data?.ERROR?.map(err => {
        const { text } = getErrorCode(err.code as unknown as ErrorsCode, t);
        return text;
    }) || [];

    const activityErrors = data?.data.flatMap(activity =>
        activity.ERROR?.map(err => {
            const { text } = getErrorCode(err.code as unknown as ErrorsCode, t);
            return text;
        }) || []
    );

    return [...userErrors, ...activityErrors];

};


export { formatUsersDataListResponse, transformErrorActivity, formatActivityDataResponse, formatUsersDataUnitsResponse, formatTypeActivityResponse }